import {Box, styled} from '@mui/material';
import React from 'react';
import {VoteEnum} from '../../types';

const LabelBox = styled(Box)(({theme}) => ({
  borderRadius: theme.typography.pxToRem(16),
  padding: `${theme.typography.pxToRem(4)} ${theme.typography.pxToRem(8)}`,
  paddingRight: theme.typography.pxToRem(12),
  display: 'flex',
  alignItems: 'center',
  textTransform: 'capitalize',
  fontSize: theme.typography.pxToRem(12),
  fontWeight: 500,
  width: 'fit-content',
  '& svg': {
    fontSize: theme.typography.pxToRem(16),
    marginRight: theme.spacing(1),
  },
}));

function getColorByVoteType(type: VoteEnum) {
  switch (type) {
    case 'yes':
      return {bg: '#21BF80', color: '#FFFFFF'};
    case 'abstain':
      return {bg: '#F5DC5D', color: '#000000'};
    case 'no':
      return {bg: '#F76A68', color: '#FFFFFF'};
    default:
      throw new Error(`Unknown vote type: ${type}`);
  }
}

interface Props {
  type: VoteEnum;
  children: React.ReactNode;
}

function VoteLabel({type, children}: Props) {
  return (
    <LabelBox
      sx={{backgroundColor: getColorByVoteType(type).bg, color: getColorByVoteType(type).color}}
    >
      {children}
    </LabelBox>
  );
}

export default VoteLabel;
